import { DESCRIPTION_DICTIONARY } from './SendSellerQuoteDialog.constants'
/**
 * Calculate idRespuesta based on the provided leyCheck.
 * @param {Object} leyCheck - Object with keys 1, 2, and 3 representing the state.
 * @returns {number} - The calculated idRespuesta.
 */
export const calculateIdRespuesta = leyCheck => {
  switch (true) {
    case leyCheck[1] === '2':
      return 9
    case leyCheck[1] === '1' && leyCheck[2] === '2':
      return 10
    case leyCheck[1] === '1' && leyCheck[2] === '1':
      return 11
    default:
      return 0
  }
}

/**
 * Update leyCheck based on a given DJIdRespuesta.
 * @param {number} DJIdRespuesta - The idRespuesta to map to a leyCheck state.
 * @returns {Object} - Updated leyCheck state.
 */
export const mapIdRespuestaToLeyCheck = DJIdRespuesta => {
  switch (DJIdRespuesta) {
    case 9:
      return { 1: '2', 2: '', 3: false }
    case 10:
      return { 1: '1', 2: '2', 3: false }
    case 11:
      return { 1: '1', 2: '1', 3: false }
    default:
      return { 1: '', 2: '', 3: false }
  }
}

/**
 * Generic handler for updating state from an event target.
 * @param {Function} setState - Setter function for the state.
 * @returns {Function} - Event handler function.
 */
export const createHandleChange = setState => {
  return ({ target }) => {
    if (!target) return
    const { name, value, checked } = target
    setState(prev => ({
      ...prev,
      [name]: value || checked
    }))
  }
}

/**
 * Translates an error response code into a standardized description.
 *
 * @param {Object} response - The error response object.
 * @param {string} [response.codigo] - The error code received.
 * @param {string} [response.descripcion] - Optional description of the error.
 * @returns {Object} - An object containing the standardized error code and description.
 */
export const translateErrorCodeQuoteResponse = ({ codigo, descripcion, code, message }) => {
  const ERROR_MAPPING = {
    '403-1': DESCRIPTION_DICTIONARY.UNAUTHORIZED,
    '403-2': DESCRIPTION_DICTIONARY.UNKNOWN,
    403: DESCRIPTION_DICTIONARY.UNAUTHORIZED
  }

  return {
    code: codigo || code || 'UNKNOWN_CODE',
    description:
      ERROR_MAPPING[codigo] || ERROR_MAPPING[code] || descripcion || message || DESCRIPTION_DICTIONARY.UNKNOWN
  }
}
